import { Component, OnInit, Output, EventEmitter, OnChanges, Input } from '@angular/core';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { SweetalertService } from 'src/app/services/sweetalert/sweetalert.service';
import { CoreTranslateService } from 'src/app/services/utilitys/utilitys.service';

@Component({
  selector: 'app-upload-image-multiple',
  templateUrl: './upload-image-multiple.component.html',
  styleUrls: ['./upload-image-multiple.component.scss']
})
export class UploadImageMultipleComponent implements OnInit, OnChanges {

  @Output() confirmCropped: EventEmitter<any> = new EventEmitter<any>();
  @Input() removeOldImage: any;
  @Input() max: any;
  croppedImage: any = '';
  img: any;
  @Input() imgs: any = [];
  imgsOutput: any = [];

  constructor(
    private swAlert: SweetalertService,
    private coreTranslate: CoreTranslateService
  ) {
  }

  ngOnInit() {
  }

  ngOnChanges(changes: any) {
    // console.log(changes);
    if(changes) {
      this.imgs = [];
      this.img = null;
      this.imgsOutput = [];
    }
  }

  fileChangeEvent(event: any): void {
    // console.log(event);
    let files = event.srcElement.files;
    if(files.length > this.max) {
      this.swAlert.error( this.coreTranslate.getWord('GENERAL.AN_ERROR_OCCURRED') , `${this.coreTranslate.getWord('CONTENT.ADD_TOP_UP_PICTURE')} ${this.max} ${this.coreTranslate.getWord('CONTENT.PICTURE')}`);
      return;
    }

    for(let i = 0; i < files.length; i++) {
      let size = (files[i].size / 1000) / 1000;
      if(size >= 19.07) {
        this.imgs[i] = null;
        this.swAlert.error( this.coreTranslate.getWord('GENERAL.AN_ERROR_OCCURRED'), 'You can only select image up to 19.07 MB in size' );
        return;
      } else {
        this.imgs[i] = files[i];
      }
    }
  }

  imageCropped(event: ImageCroppedEvent, index: any) {
    try {
      // this.croppedImage = event.base64;
      this.imgsOutput[index] = event.base64;
    } catch(err) {
      console.log(err);
    }
  }

  imageLoaded() {
    // show cropper
    console.log('imageLoaded');
  }

  cropperReady() {
    // cropper ready
  }

  loadImageFailed() {
    // show message
    console.log('loadImageFailed');
  }

  confirm() {
  
    this.confirmCropped.emit(this.imgsOutput);
  }

}
